import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import axios from 'axios'

const PropsDemo = (props) => {
    const [apiArr, setApiArr] = useState([])
    const [arr, setArr] = useState([])
    let [index, setIndex] = useState(0)
    let [count, setCount] = useState(0)

    useEffect(() => {
        axios.get(`https://jsonplaceholder.typicode.com/photos`)
            .then((res) => {
                console.log(res?.data);
                setArr(res?.data)
            })
    }, [])

    useEffect(() => {
        if (arr.length) {
            setApiArr(arr.slice(index, index + 10))
            setIndex(index + 10)
        }
    }, [count])

    const next = () => {
        // setIndex(index++)
        setCount(count++)
    }

    return (
        <div>
            <p>{index}</p>
            <p>{count}</p>
            <button onClick={next}>Next</button>
            {(!apiArr.length) ? <p>Sabur ady...</p> : <p>{apiArr?.map((v, i) => {
                return (
                    <img src={v.thumbnailUrl} key={i}></img>
                )
            })}</p>}
        </div >
    )
}

PropsDemo.propTypes = {
    msg: PropTypes.string.isRequired,
}
PropsDemo.defaultProps = {
    msg: 'This is default props'
}

export default PropsDemo